import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
   MatButtonModule,
   MatTabsModule,
   MatToolbarModule,
   MatIconModule,
   MatBadgeModule,
   MatSidenavModule,
   MatTreeModule,
   MatListModule,
   MatGridListModule,
   MatFormFieldModule,
   MatCheckboxModule,
   MatInputModule,
   MatSelectModule,
   MatRadioModule,
   MatDatepickerModule,
   MatNativeDateModule,
   MatChipsModule,
   MatTooltipModule,
   MatTableModule,
   MatSortModule,
   MatPaginatorModule,
   MatMenuModule,
   MatSnackBarModule,
   MatCardModule,
   MatStepperModule
} from '@angular/material';

@NgModule({
   imports: [
      CommonModule,
      MatButtonModule,
      MatTabsModule,
      MatTreeModule,
      MatToolbarModule,
      MatIconModule,
      MatSidenavModule,
      MatBadgeModule,
      MatListModule,
      MatGridListModule,
      MatFormFieldModule,
      MatInputModule,
      MatSelectModule,
      MatRadioModule,
      MatDatepickerModule,
      MatNativeDateModule,
      MatChipsModule,
      MatSnackBarModule,
      MatTooltipModule,
      MatTableModule,
      MatSortModule,
      MatPaginatorModule,
      MatMenuModule,
      MatCardModule,
      MatCheckboxModule,
      MatStepperModule,
   ],
   exports: [
      MatButtonModule,
      MatTabsModule,
      MatToolbarModule,
      MatIconModule,
      MatTreeModule,
      MatSidenavModule,
      MatBadgeModule,
      MatListModule,
      MatGridListModule,
      MatInputModule,
      MatFormFieldModule,
      MatSelectModule,
      MatRadioModule,
      MatDatepickerModule,
      MatChipsModule,
      MatTooltipModule,
      MatTableModule,
      MatPaginatorModule,
      MatMenuModule,
      MatCardModule, 
      MatSnackBarModule,
      MatCheckboxModule,
      MatStepperModule,
      MatSortModule
   ],
   providers: [
      MatDatepickerModule,
   ]
})

export class AngularMaterialModule { }